import Images from 'assets/Images';
import PropTypes from 'prop-types';
import './styles.scss';

export default function NoRecord(props) {
	const { header, description, height, imageHeight, imageWidth } = props;
	return (
		<>
			<div className='align-center no-data' style={{ height }}>
				<div className='no-data__content'>
					<img src={Images.noData} style={{ height: imageHeight, width: imageWidth }} alt='no-data' />
					<h2>{header}</h2>
					<p>{description}</p>
				</div>
			</div>
		</>
	);
}

NoRecord.propTypes = {
	height: PropTypes.any,
	imageHeight: PropTypes.string,
	imageWidth: PropTypes.string,
	header: PropTypes.string,
	description: PropTypes.string
};

NoRecord.defaultProps = {
	height: 'calc(100vh - 125px)',
	header: 'No data found',
	description: '',
	imageHeight: '180px',
	imageWidth: '180px'
};
